import { useQuery } from "@tanstack/react-query"
import { fetcher } from "../fetcher"

export type CustomerNotificationsPushes = {
  newsPush: boolean
  overdraftWarningsPush: boolean
  paymentStatusPush: boolean
  paymentDuePush: boolean
}

export type CustomerNotificationsEmails = {
  newsEmail: boolean
  overdraftWarningsEmail: boolean
  paymentStatusEmail: boolean
  paymentDueEmail: boolean
}

export type CustomerNotificationsResponse = CustomerNotificationsPushes &
  CustomerNotificationsEmails

export function useCustomerNotifications() {
  return useQuery<CustomerNotificationsResponse>({
    queryKey: ["CustomerNotifications"],
    queryFn: async () => {
      const response = await fetcher(
        "/Customer/Notifications",
        {
          method: "GET",
        },
        {
          useAccessToken: true,
        }
      )
      const responseJson = await response.json()

      return responseJson
    },
  })
}
